// Wire shapes shared by every kind (resources.md §2.3, ADR-021, ADR-028, ADR-032). Per-kind spec and status types
// come from the OpenAPI documents through orval (src/gen); these envelope types are what the client, watch and
// shell need alongside them, and the ones the documents already describe exactly are the generated ones.
import type { Cost, ListMeta } from "./gen/nodus_dev_v1/model";

export type { Cost, ListMeta };

export interface ObjectMeta {
  name: string;
  namespace?: string;
  uid?: string;
  resourceVersion?: string;
  generation?: number;
  creationTimestamp?: string;
  deletionTimestamp?: string;
  labels?: Record<string, string>;
  annotations?: Record<string, string>;
  ownerReferences?: { apiVersion: string; kind: string; name: string; uid: string; controller?: boolean }[];
  finalizers?: string[];
  generateName?: string;
}

export interface Condition {
  type: string;
  status: "True" | "False" | "Unknown";
  reason?: string;
  message?: string;
  lastTransitionTime?: string;
  observedGeneration?: number;
}

/** The status fields the shell reads on any kind; kinds add their own. */
export interface CommonStatus {
  phase?: string;
  reason?: string;
  message?: string;
  fix?: string;
  stopReason?: string;
  conditions?: Condition[];
  cost?: Cost;
  observedGeneration?: number;
  [key: string]: unknown;
}

export interface KObject<Spec = Record<string, unknown>, Status = CommonStatus> {
  apiVersion: string;
  kind: string;
  metadata: ObjectMeta;
  spec?: Spec;
  status?: Status;
}

export interface KList<T extends KObject = KObject> {
  apiVersion: string;
  kind: string;
  metadata: ListMeta;
  items: T[];
}

export type WatchEventType = "ADDED" | "MODIFIED" | "DELETED" | "BOOKMARK" | "ERROR";

export interface WatchEvent<T extends KObject = KObject> {
  type: WatchEventType;
  /** The object; a `Status` for ERROR events; only metadata.resourceVersion for BOOKMARK. */
  object: T | Status;
}

export interface StatusCause {
  reason?: string;
  message?: string;
  field?: string;
}

/** `metav1.Status` with the Nodus `fix`, `docs` and `requestId` (ADR-028). */
export interface Status {
  apiVersion?: "v1";
  kind: "Status";
  status?: "Success" | "Failure";
  message?: string;
  reason?: string;
  code?: number;
  details?: {
    name?: string;
    kind?: string;
    group?: string;
    causes?: StatusCause[];
    retryAfterSeconds?: number;
    [key: string]: unknown;
  };
  fix?: string;
  docs?: string;
  requestId?: string;
}

export function isStatus(v: unknown): v is Status {
  return typeof v === "object" && v !== null && (v as { kind?: unknown }).kind === "Status";
}

/** Org and project a request or page is scoped to; every query key starts with them (ui-spec §4.18). */
export interface Scope {
  org: string;
  project?: string;
}
